"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const constants_2 = require("./constants");
exports.default = theme => ({
    root: {
        listStyle: 'none',
        flexShrink: 0,
        'li + &': {
            paddingTop: 7
        },
        '&:not(:last-child)': {
            paddingBottom: 7
        }
    },
    link: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        boxSizing: 'border-box',
        flexShrink: 0,
        outline: 'none',
        position: 'relative',
        lineHeight: constants_2.MENU_LINE_HEIGHT,
        fontWeight: 400,
        color: theme.grey3,
        textDecoration: 'none',
        '&::before': {
            content: '""',
            position: 'absolute',
            height: constants_1.MIN_TARGET_SIZE,
            top: '50%',
            left: 0,
            right: 0,
            transform: 'translateY(-50%)'
        },
        '&:not([data-is-selected=true]):hover': {
            color: theme.indigo3
        },
        '&[data-is-selected=true]': {
            color: theme.grey1
        }
    },
    label: {
        fontSize: constants_2.MENU_FONT_SIZE,
        fontWeight: 'inherit',
        lineHeight: 'inherit',
        color: 'inherit',
        ':not(:hover):focus > &': {
            textDecoration: 'underline'
        }
    },
    icon: {
        marginRight: 14,
        flexShrink: 0,
        width: 20,
        minHeight: constants_2.MENU_FONT_SIZE * constants_2.MENU_LINE_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        color: 'inherit'
    },
    suffix: {
        marginLeft: 14,
        flexShrink: 0,
        minHeight: constants_2.MENU_FONT_SIZE * constants_2.MENU_LINE_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        color: 'inherit'
    }
});
//# sourceMappingURL=menu.item.href.style.js.map